import React from "react";
import { DateCellWrapperProps } from "react-big-calendar";
import styled from "styled-components";
import { FontSize } from "@themes/Fonts";

const TimeSlot = styled.div`
    padding: 0 3px 0 5px;
`;

const TimeText = styled.span`
    font-size: ${FontSize.small};
    color: ${(props) => props.theme.textColorSecondary};
`;

function CalendarTimeSlotWrapper(props: DateCellWrapperProps) {
    const timeComponent = props.children?.props?.children?.props;
    let timeString = undefined;

    // Note: this component is a wrapper for the times and events
    // if the child is a time label, shorten the label, otherwise
    // just display the children components
    if (timeComponent?.className === "rbc-label") {
        timeString = timeComponent?.children.replace(":00", "");
    }

    const content = timeString ? <TimeText className="time-slot-text-label"> {timeString} </TimeText> : props.children;

    return (
        <div className="time-slot-wrapper">
            <TimeSlot className="time-slot">{content}</TimeSlot>
        </div>
    );
}

export default CalendarTimeSlotWrapper;
